<template>
  <div class="wrap">
    <div class="title">{{ currentConstruction.cloud_construction_name }}</div>
    <div class="folder-list">
      <div class="folder">
        <router-link :to="{ name: 'create-kokuban-input' }">黒板用書類データ</router-link>
      </div>
      <div class="folder">
        <router-link :to="{ name: 'create-kokuban-output' }">黒板確認</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConstructionFolder',
  props: {
    currentConstruction: Object
  }
}
</script>

<style scoped>
.wrap {
  padding: 3rem;
}
.title {
  border-bottom: solid 1px #333;
  font-size: 1.4rem;
  font-weight: bold;
  padding: 2rem 1rem;
}
.folder-list {
  padding: 3rem 1rem;
}
.folder {
  padding: 0.8rem 0;
}
.folder a {
  display: block;
  border: solid 1px #ccc;
  color: #333;
  cursor: pointer;
  font-size: 1.1rem;
  font-weight: bold;
  padding: 1.5rem 2rem;
  text-decoration: none;
}
</style>